import ParticipantDiscourseResults from '../../participant/discourse/results'
import DiscourseResult from './result'

export default class DiscourseResults extends ParticipantDiscourseResults {
  get model () { return DiscourseResult }

  initialize (models, options = {}) {
    super.initialize(models, options)
    this.changeSort('top')
  }
}
